import React from 'react'
import ListItemProductPreview from './ListItemProductPreview'
import { getListItemInterfacesDisplayText } from './listItemUtils'
import { ListPrice } from './ListPrice'
import { InflatedListItemProduct } from './ListTypes'
import ProductLedTag from './ProductLedTag'
import { ProductPriceAvailable, ProductPriceUnavailable } from '../productPricing/ProductPricingContext'
import { PriceTypeLabel } from './PriceTypeLabel'
import { getProductDisplayNames } from '../utils/getProductDisplayNames'

interface ListItemDetailsProps {
  configuredProduct: InflatedListItemProduct
  showPrice: boolean
  // isAuthenticated: boolean
  priceLoading?: boolean
  price: ProductPriceAvailable | typeof ProductPriceUnavailable
  priceDisclaimer: string | null
  priceTypeLabel?: PriceTypeLabel
}

export const ListItemDetails: React.FC<ListItemDetailsProps> = (props) => {
  const { configuredProduct, showPrice, priceLoading, price, priceDisclaimer, priceTypeLabel } = props

  const interfaces = getListItemInterfacesDisplayText(configuredProduct)

  const { primary: primaryItemHeading, secondary: secondaryItemHeading }
    = getProductDisplayNames(configuredProduct.skinProduct)

  return (
    <div className="topRow">
      <ListItemProductPreview configuredProduct={configuredProduct} size="80px" />
      <div className="rowText">
        <div className="details">
          <div className="skinStyle">
            {primaryItemHeading}
          </div>
          <div className="skinName">{secondaryItemHeading}</div>
          <ProductLedTag configuredProduct={configuredProduct} />
          {
            interfaces && (
              <div className="components">
                {interfaces.map((el, it) => {
                  return <div key={`${el}-${it}`}>{el}</div>
                })}
              </div>
            )
          }
        </div>
        {showPrice && (
          <div className="priceSection">
            <ListPrice
              price={price}
              priceLoading={priceLoading}
              priceDisclaimer={priceDisclaimer}
              showPrice={showPrice}
              priceTypeLabel={priceTypeLabel}
            />
          </div>
        )}
      </div>
    </div>
  )
}